import axios from 'axios'
import {getTranslationUrl} from './api_urls'

const ids = [133,408,1066,1860,1859,1861,1862,1863,1478,1541,1022,93,94,1836,1717,1837,1838,1839,1840,1857,1841,1842,1843,1844,1845,1846,1858/*,1859*/,46,1847,1848,716,717,1354,1849,1850,1851,1852,1853,1854,1855,1856];
var translations = null;

/**
 * Set Translations as per locale
 * @param {string} locale 
 */
export function setTranslations(callingClass, locale){

  
  axios(getTranslationUrl(),{
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    data: {
        "translations": {
          "ids": ids.join(','),
          "locales": locale
        }
      }
  })
  .then(
        (result)=>{
          let response = result.data;
          //console.log(response);
          translations = response;
          callingClass.translationCallback(locale);
        }).catch(
          (error)=>{
            console.log(error);
          }
        );}

export function getTranslation(id, defaultWord){
    if(translations!==null){
        if(translations[id]!==undefined){
          if((translations[id][Object.keys(translations[id])[0]])!==''){
            var parser = new DOMParser();
            return parser.parseFromString(translations[id][Object.keys(translations[id])[0]], 'text/html').body.textContent;
          }
          else
            return defaultWord;
        }else{
            return defaultWord;
        }
    }else{
        return defaultWord;
    }
}